import React from "react";
import { useSelector } from "react-redux";
import VerifyEmailMessage from "../../components/Messages/VerifyEmailMessage";
import UpgradeMessage from "../../components/Messages/UpgradeMessage";
import { useUser } from "../../contexts/UserContext";
import { useAuth } from "../../contexts/AuthContext";
import { useInvitations } from "../../contexts/InvitationsContext";
import InvitationMessage from "../../components/Messages/InvitationMessage";
import BetaAnnouncementMessage from "../../components/Messages/BetaMessage";

const Banners = () => {
  const { currentUser } = useUser();
  const { user } = useAuth();
  const { invitations } = useInvitations();

  if (!currentUser) return null;

  const showUpgradeMessage = currentUser.account_level === "basic" && 
                             (!invitations || invitations.length === 0);

  return (
    <div style={{ position: "relative" }}>
      {/* Beta announcement with highest priority */}
      <BetaAnnouncementMessage />
      
      {/* Email verification is critical */}
      {!user.emailVerified && <VerifyEmailMessage />}

      {/* Invitations take precedence over upgrade messages */}
      {invitations && invitations.length > 0 && (
        <>
          {invitations.map((invitation) => (
            <InvitationMessage key={invitation._id} invitation={invitation} />
          ))}
        </>
      )}
      
      {/* Show upgrade message only if no invitations and user is basic */}
      {showUpgradeMessage && <UpgradeMessage />}
    </div>
  );
};

export default Banners;